/** 订单业务类型 */
export enum OrderBusinessType {
    /** 普通外卖订单 */
    WM = 1,
    /** 拼好饭订单 */
    PHF = 2,
}

/** 订单类型（用户下单维度） */
export enum OrderType {
    /** 普通订单 */
    NONE = 0,
    /** 拼好饭单买订单 */
    ORDINARY = 10,
    /** 拼好饭拼单-主单 */
    PHF_MAIN = 20,
    /** 拼好饭拼单-子单 */
    PHF_SUB = 30,
}
